import posthog from 'posthog-js';

const apiKey = import.meta.env.VITE_POSTHOG_KEY;

if (apiKey) {
  posthog.init(apiKey, {
    api_host: 'https://eu.i.posthog.com',
    autocapture: false,
    capture_pageview: false,
    persistence: 'localStorage',
  });
}

export function identify(userId: string, properties?: Record<string, unknown>) {
  if (!apiKey) return;
  posthog.identify(userId, properties);
}

export function track(event: string, properties?: Record<string, unknown>) {
  if (!apiKey) return;
  posthog.capture(event, properties);
}

export function resetAnalytics() {
  if (!apiKey) return;
  posthog.reset();
}
